import Vue from "vue";
import VueAnalytics from "vue-analytics";
import axios from "axios";
import VueAxios from "vue-axios";
import VueLocalStorage from "vue-ls";
import VueApexCharts from "vue-apexcharts";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";

Vue.config.productionTip = false;
Vue.use(VueAnalytics, { id: "UA-180104565-1", router });
Vue.use(VueAxios, axios);
Vue.use(VueLocalStorage, { namespace: "dxcm_", name: "ls" });
Vue.component("apexchart", VueApexCharts);
// axios.defaults.baseURL = "http://localhost:10111/DraftworxCustomerManager";
axios.defaults.baseURL = "https://license.draftworx.com/cm_api";

// This is a global mixin, it is applied to every vue instance.
Vue.mixin({
    methods: {
        // App is listeting for the TO_Notification. Will display an alert/snackbar with the options.
        $alert(options) {
            this.$root.$emit("DX_Notification", options);
        },
        $confirm(options, done) {
            this.$root.$emit("DX_Confirm", options);
            this.$root.$once("DX_Confirm_Result", done);
        },
        $prompt(options, done) {
            this.$root.$emit("DX_Prompt", options);
            this.$root.$once("DX_Prompt_Result", done);
        },
        $process(options) {
            this.$root.$emit("DX_Process", options);
        },
    },
});

Vue.prototype.$global = {
    application: "za.co.dataprime.vue.licensemanager",
    login: {
        loggedIn: false,
        email: "",
        firmGUID: "",
        user: "",
        userDescription: "",
        administrator: "",
        userTypeGUID: "",
        dealerGUID: "",
    },
};

new Vue({
    router,
    vuetify,
    render: h => h(App),
}).$mount("#app");

Vue.directive("uppercase", {
    update(el) {
        el.value = el.value.toUpperCase();
    },
});
